/* eslint-disable jsx-a11y/click-events-have-key-events */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { createCustomPropType, isNumeric } from '../../../../js/app/react/validators';
import AdvForm from '../../../CommonComponents/AdvForm';
import { Contributions } from '../../AccountsWorkflow/components/Contributions';
import BackMobileNavigation from '../../BackMobileNavigation/BackMobileNavigationView';
import DateInput from '../../DateInput/DateInputView';
import Input, { LEFT } from '../../Input/InputView';
import InputDollar from '../../InputDollar/InputDollarView';
import SimpleSelect from '../../SimpleSelect/SimpleSelectView';
import Validation from '../../Validation/ValidationContainer';
import {
  BACKEND_KEY,
  DOLLAR_CONTRIBUTION,
  NO_CONTRIBUTION,
  PERCENTAGE_CONTRIBUTION,
} from '../FinancialAccountsWorkflowConstants';
import { RothBalances } from '../../AccountsWorkflow/components/RothBalances';
import { ACCOUNTS_WITH_HOLDINGS_TAB } from '../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/AccountForm.meta';
import { parsePositionValue } from '../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/utils/parsePositionValue';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { formatCurrency } from '../../../CommonUtils/formatNumber';
import { AccountOwnership } from '../../AccountsWorkflow/components/AccountOwnership/AccountOwnership';
import { useOwnershipValidation } from '../../AccountsWorkflow/components/AccountOwnership/useOwnershipValidation';
import { Alert } from '../../../CommonComponents/OPL/Alert/Alert';

class AccountAddEditView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOwnershipError: false,
    };
  }
  componentDidMount() {
    const {
      account,
      workflowId,
      clientId,
      mapEmployerMatch,
      isEmployerMatchableRetirementAccount,
    } = this.props;

    if (isEmployerMatchableRetirementAccount) {
      mapEmployerMatch(account, workflowId, clientId);
    }
  }

  render() {
    const {
      workflowId,
      clientId,
      onCancel,
      onSave,
      accountInputChanged,

      accountSimpleSelectChanged,
      accountTypeChanged,
      accountDateChanged,
      contributionTypeChanged,
      graphAccounts,
      groups,

      account,

      accountTypeOption,
      accountTypesOptions,

      accountOwnerOption,
      accountOwnersOptions,
      accountOwnersGroups,
      dollarContributionKeyName,
      percentageContributionKeyName,

      mortgageTypeOption,
      mortgageTypesOptions,

      isMortgageAccount,

      monthlyContributionAmountLabel,
      contributionType,

      previousViewId,

      isEmployerMatchableRetirementAccount,

      canEmployeeMaxContribution,
      hasMaximizeContributions,
      contributionPeriod,
      hasContributionPeriodOption,
      hasContributionPercentOption,

      accountTypes,
      updateDraftAccount,
      isStudentLoanAccount,

      accountOwners,
      ownerModel,
    } = this.props;

    const showMarketValueBreakdown =
      ACCOUNTS_WITH_HOLDINGS_TAB.includes(account.AccountType) &&
      parsePositionValue(account.SpecificPositionsValue) > 0;

    const nonSpecificPositionsValueInput = (
      <InputDollar
        maxLength="256"
        placeholder={showMarketValueBreakdown ? 'Non-Specific Holdings' : 'Balance'}
        id={showMarketValueBreakdown ? 'adv-non-specific-holdings' : 'adv-balance'}
        className="accounts"
        isLeftAligned
        value={account.NonSpecificPositionsValue}
        onChange={accountInputChanged('NonSpecificPositionsValue', workflowId, clientId)}
      />
    );

    return (
      <AdvForm className="AccountAddEditView with-mobile-top-padding">
        <BackMobileNavigation
          label="Add Account"
          onBack={onCancel(workflowId, clientId, account, graphAccounts, previousViewId)}
        />
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.AccountAddEdit`} />
        {this.state.isOwnershipError && (
          <Alert
            mt="16"
            mb="16"
            message={'The total ownership percentage must add up to 100%'}
            variant="error"
          />
        )}
        <h2 className="h2">Please add your account information.</h2>

        <ul className="form-input-list">
          <li className="form-input">
            <SimpleSelect
              placeholder="Account Type"
              id="adv-account-type"
              className="no-horizontal-scroll sm"
              value={accountTypeOption}
              options={accountTypesOptions}
              isLeftAligned
              groups={groups}
              onValueChange={accountTypeChanged(workflowId, clientId)}
            />
          </li>

          {account.AccountType !== undefined && (
            <AccountOwnership
              selectedAccountType={account.AccountType}
              ownerModel={ownerModel}
              updateAccount={updateDraftAccount}
              accountTypes={accountTypes}
              accountOwners={accountOwners}
              clientId={clientId}
            />
          )}

          {isMortgageAccount && (
            <li className="form-input">
              <SimpleSelect
                placeholder="Mortgage Type"
                id="adv-mortgage-type"
                className="no-horizontal-scroll sm"
                isLeftAligned
                value={mortgageTypeOption}
                options={mortgageTypesOptions}
                onValueChange={accountSimpleSelectChanged('MortgageType', workflowId, clientId)}
              />
            </li>
          )}

          {(!account.IsLinked || account.IsLinkBroken) && (
            <li className="form-input">
              {showMarketValueBreakdown ? (
                <Box width={240} display="flex" flexDirection="column" ml={28}>
                  <InputDollar
                    disabled
                    maxLength="256"
                    placeholder="Specific Holdings"
                    id="adv-specific-holdings"
                    className="accounts"
                    isLeftAligned
                    value={account.SpecificPositionsValue}
                  />

                  <Box mt="40">{nonSpecificPositionsValueInput}</Box>

                  <Box>
                    <p
                      style={{ position: 'relative', textAlign: 'left' }}
                      className="adv-workflow-input-placeholder-left"
                    >
                      Total Current Market Value
                    </p>
                    <p style={{ textAlign: 'left', fontWeight: 600 }}>
                      {formatCurrency(
                        parsePositionValue(account.SpecificPositionsValue) +
                          parsePositionValue(account.NonSpecificPositionsValue),
                      )}
                    </p>
                  </Box>
                </Box>
              ) : (
                nonSpecificPositionsValueInput
              )}
            </li>
          )}

          {(isMortgageAccount || isStudentLoanAccount) &&
            (() => {
              const fieldName = isMortgageAccount
                ? 'OriginationDate'
                : 'StudentLoanOriginationDate';
              return (
                <li className="form-input has-calendar">
                  <DateInput
                    id="adv-origination-date"
                    placeholder="Origination Date"
                    value={account[fieldName]}
                    onChange={accountDateChanged(fieldName, workflowId, clientId)}
                    maxDate={isStudentLoanAccount ? new Date() : undefined}
                  />
                </li>
              );
            })()}

          {!isMortgageAccount && (
            <li className="form-input">
              <Input
                type="text"
                maxLength="256"
                alignment={LEFT}
                id="adv-account-description"
                placeholder="Account Description"
                className="nickname"
                value={account.AccountName}
                readOnly={account.IsOrion}
                onChange={accountInputChanged('AccountName', workflowId, clientId)}
              />
            </li>
          )}

          <RothBalances
            account={account}
            updateAccount={updateDraftAccount}
            accountTypes={accountTypes}
          />

          {(contributionType === DOLLAR_CONTRIBUTION ||
            contributionType === PERCENTAGE_CONTRIBUTION) && (
            <Contributions
              account={account}
              contributionType={contributionType}
              hasContributionPeriodOption={hasContributionPeriodOption}
              contributionLabel={monthlyContributionAmountLabel}
              accountInputChanged={accountInputChanged}
              workflowId={workflowId}
              clientId={clientId}
              contributionPeriod={contributionPeriod}
              hasMaximizeContributions={hasMaximizeContributions}
              canEmployeeMaxContribution={canEmployeeMaxContribution}
              dollarContributionKeyName={dollarContributionKeyName}
              percentageContributionTitle={monthlyContributionAmountLabel}
              percentageContributionKeyName={percentageContributionKeyName}
              hasContributionPercentOption={hasContributionPercentOption}
              isEmployerMatchableRetirementAccount={isEmployerMatchableRetirementAccount}
              updateDraftAccount={updateDraftAccount}
              contributionTypeChanged={contributionTypeChanged}
              accountTypeOption={accountTypeOption}
            />
          )}
        </ul>
        <div className="footer">
          <button
            type="button"
            className="adv-workflow-navigation-cancel-button"
            onClick={onCancel(workflowId, clientId, account, graphAccounts, previousViewId)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="adv-workflow-navigation-next-save-button"
            onClick={() => {
              const validation = useOwnershipValidation(account.OwnerModel);
              this.setState({
                isOwnershipError: !validation,
              });
              if (validation) {
                onSave(
                  {
                    ...(hasContributionPeriodOption
                      ? { ...account, ContributionPeriod: contributionPeriod }
                      : account),
                    OwnerModel: account.OwnerModel?.filter(b => b.Name && b.percent).map(owner => ({
                      ...owner,
                      Percentage: Number((parseFloat(owner.percent ?? '0') / 100).toFixed(4)),
                    })),
                  },
                  graphAccounts,
                  workflowId,
                  clientId,
                );
              }
            }}
          >
            Save Account
          </button>
        </div>
      </AdvForm>
    );
  }
}

AccountAddEditView.defaultProps = {
  canEmployeeMaxContribution: false,
};

AccountAddEditView.propTypes = {
  monthlyContributionAmountLabel: PropTypes.string.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  workflowId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  isMortgageAccount: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  accountSimpleSelectChanged: PropTypes.func.isRequired,
  accountInputChanged: PropTypes.func.isRequired,
  accountTypeChanged: PropTypes.func.isRequired,
  accountDateChanged: PropTypes.func.isRequired,
  contribution: createCustomPropType(isNumeric).isRequired,
  contributionType: PropTypes.oneOf([DOLLAR_CONTRIBUTION, PERCENTAGE_CONTRIBUTION, NO_CONTRIBUTION])
    .isRequired,
  contributionTypeChanged: PropTypes.func.isRequired,

  accountTypeOption: PropTypes.shape({}).isRequired,
  mortgageTypeOption: PropTypes.number.isRequired,
  accountOwnerOption: PropTypes.shape({}).isRequired,

  accountOwnersGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  accountTypesOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  mortgageTypesOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  accountOwnersOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dollarContributionKeyName: PropTypes.string.isRequired,
  percentageContributionKeyName: PropTypes.string.isRequired,

  account: PropTypes.shape({
    AccountName: PropTypes.string,
    NonSpecificPositionsValue: PropTypes.string,
    EmployerMultiTierMatch: PropTypes.arrayOf(
      PropTypes.shape({
        Match: PropTypes.string,
        Limit: PropTypes.string,
      }),
    ),
    EmployerNonElectiveContribution: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    EmployerMatchType: PropTypes.number,
    IsLinked: PropTypes.bool,
    IsLinkBroken: PropTypes.bool,
    OriginationDate: PropTypes.string,
    IsOrion: PropTypes.bool,
    AccountType: PropTypes.number,
    GroupId: PropTypes.string,
    SpecificPositionsValue: PropTypes.number,
  }).isRequired,
  graphAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  previousViewId: PropTypes.string.isRequired,

  isEmployerSponsoredRetirementAccount: PropTypes.bool.isRequired,
  isEmployerMatchableRetirementAccount: PropTypes.bool.isRequired,

  mapEmployerMatch: PropTypes.func.isRequired,
  canEmployeeMaxContribution: PropTypes.bool,
  contributionPeriod: PropTypes.number.isRequired,
  hasMaximizeContributions: PropTypes.bool.isRequired,
  hasContributionPeriodOption: PropTypes.bool.isRequired,
  hasContributionPercentOption: PropTypes.bool.isRequired,
};

export default AccountAddEditView;
